import { cva, type VariantProps } from 'class-variance-authority';
import { forwardRef } from 'react';
import { cn } from '../utils/cn';

const cardVariants = cva('rounded-2xl transition-[transform,box-shadow,border-color] duration-base ease-mela', {
  variants: {
    variant: {
      white: 'bg-white border border-ink-200',
      soft: 'bg-bg-soft border border-ink-200',
      saffron:
        'bg-gradient-to-br from-saffron-50 to-saffron-100 border border-saffron-200',
      violet:
        'bg-gradient-to-br from-violet-50 to-violet-100 border border-violet-200',
      gold:
        'bg-gradient-to-br from-gold-50 to-gold-100 border border-gold-200',
      ink: 'bg-ink-900 text-white relative overflow-hidden border border-ink-800',
    },
    interactive: {
      true: 'cursor-pointer hover:-translate-y-0.5 hover:shadow-elevated',
      false: '',
    },
    padding: {
      none: 'p-0',
      sm: 'p-4',
      md: 'p-6',
      lg: 'p-8',
    },
  },
  defaultVariants: { variant: 'white', interactive: false, padding: 'md' },
});

export interface CardProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof cardVariants> {}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ className, variant, interactive, padding, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(cardVariants({ variant, interactive, padding }), className)}
      {...props}
    />
  )
);
Card.displayName = 'Card';
